import React from 'react'
import './BookSkeleton.css'

function BookSkeleton() {
  return (
    // <d
                 <div className="w-full rounded h-1/2 lg:w-1/4">
                     <div className="button-wrapper">
                         <div className="image-container">
                             <div className="image-placeholder"></div>
                             <div className="text-container">
                                 {/* <div className="button-text">Caramelo</div> */}
                             </div>
                         </div>
                     </div>
                 </div>

  )
}


function DescriptionSkeleton() {
  return (
    <div className="bg-white ">

  <div className="max-w-4xl mx-auto">
    <div className="space-y-4 animate-pulse">
      <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="w-1/2 h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="w-3/4 h-4 bg-gray-200 rounded"></div>
    </div>

    {/* <div className="mt-12 space-y-4 animate-pulse">
      <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="w-1/2 h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
      <div className="h-4 bg-gray-200 rounded"></div>
    </div> */}
  </div>
</div>
  )
}

export { BookSkeleton, DescriptionSkeleton };

